import { Component, ViewChild } from '@angular/core';
import {DocumentoProcessoService} from "../../../services/documento-processo.service";
import {ItemDocumento, ListaDocumento} from "../../../models/lista-documento";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {ToastrService} from "ngx-toastr";
import {ItemAtendimento} from "../../../../cadastro/models/lista-atendimento";
import {DatePipe} from "@angular/common";
import { finalize } from 'rxjs';
import { NovoComponent } from '../novo/novo.component';

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoComponent) novoDocumentoComponent: NovoComponent;
  loading = true;
  public colunas = [`Id`, `Arquivo`, 'Processo', 'Extensão', 'Data'];
  public linhas: any[] = [];
  listaDocumentos = new ListaDocumento();

  constructor(private documentoService: DocumentoProcessoService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.buscarListaDocumentoProcesso();
  }

  abrirModalNovoDocumento(){
    this.novoDocumentoComponent.showModalNovoDocumento();
  }

  public buscarListaDocumentoProcesso(){
    this.loading = true;
    this.documentoService.selecionarLista()
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (response: any) => {
          if(response.sucesso){
            this.listaDocumentos = response.dados;
            this.preencherLista(response.dados.itens);
          }
        },
        error: (error: any) => {
          if(error.status === 404){
            this.toastr.warning("Lista de documentos vazia");
          }
          else{
            this.toastr.error("Erro ao buscar a listagem - HTTP " + error.status );
          }
        }
      });
  }

  preencherLista(listaItens: ItemDocumento[]){
    this.linhas = [];
    for(let item of (listaItens || [])) {
      let stringArray: string[] = [];
      const id = item?.id != null ? item.id.toString() : '—';
      const descricao = item?.descricao ?? '—';
      const processoTitulo = item?.processo ?? '—';
      const extensao = item?.extensao ?? '—';
      const data = this.datePipe.transform(item?.dataCadastro ?? null, 'dd/MM/yyyy') as string ?? '—';
      stringArray.push(id, descricao, processoTitulo, extensao, data);
      this.linhas.push(stringArray);
    }
  }
}
